<template>
	<div>
        <div class="container">
            <div class="row section-separator">
              <div class="col-sm-12 col-md-6">
                <div class="mh-about-img shadow-2 wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.4s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.4s; animation-name: none;">
                  <img src="/static/images/ab-img.png" alt="" class="img-fluid">
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="mh-about-inner">
                  <h2 class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.1s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.1s; animation-name: none;">
                    {{ $t('about.aboutMe') }}
                  </h2>
                  <p class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: none;">
                    {{ $t('about.aboutMeDescription') }}
                  </p>
                  <div class="mh-about-tag wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.3s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.3s; animation-name: none;">
                    <ul class="pl-0">
                        <div>
                            <span>{{ $t('about.backend') }}:</span>
                            <li><span>Java</span></li>
                            <li><span>SpringBoot</span></li>
                            <li><span>MyBatis-Plus</span></li>
                            <li><span>MyBatis-Plus-Join</span></li>
                        </div>
                        <div>
                            <span>{{ $t('about.frontend') }}:</span>
                            <li><span>Next.js</span></li>
                            <li><span>Vue.js</span></li>
                            <li><span>JavaScript</span></li>
                            <li><span>TypeScript</span></li>
                            <li><span>Tailwind CSS</span></li>
                            <li><span>Vuetify</span></li>
                            <li><span>Radix UI</span></li>
                            <li><span>Element UI</span></li>
                        </div>
                        <div>
                            <span>{{ $t('about.database') }}:</span>
                            <li><span>MySQL</span></li>
                            <li><span>Redis</span></li>
                        </div>
                        <div>
                            <span>{{ $t('about.server') }}:</span>
                            <li><span>Linux</span></li>
                            <li><span>Nginx</span></li>
                            <li><span>Cloudflare</span></li>
                            <li><span>Vercel</span></li>
                        </div>
                        <div>
                            <span>Web3:</span>
                            <li><span>Web3j (Java)</span></li>
                            <li><span>Web3.js (JS)</span></li>
                        </div>
                    </ul>
                  </div>
                  <!-- <a href="" class="btn btn-fill wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.4s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.4s; animation-name: none;">
                    {{ $t('about.downloadCV') }} <i class="fa fa-download"></i>
                  </a> -->
                </div>
              </div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    components: {  },
    created(){

    },
    mounted(){

    },
    computed: {

    },
    watch:{

    },
    methods: {

    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/About.vue